// src/auth/Auth.js
/* eslint-disable */

import axios from '@/services/axios.js'
import store from '@/store/store.js'
import { headers, getHeadersWithAccessToken, getHeadersWithRefreshToken } from '../functions.js'

class Auth {

    isAccessTokenValid () {
        if (localStorage.getItem('access_token') && localStorage.getItem('expires_at') && Math.floor(Date.now() / 1000) < localStorage.getItem('expires_at')) {
            return true
        } else {
            return false
        }
    }


    login (email,pass) {
        return axios.post(((store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/login' , {"email": email, "password": pass}, { headers: headers })
        .then(response => {
            localStorage.setItem('access_token', response.data.access_token)
            localStorage.setItem('refresh_token', response.data.refresh_token)
            localStorage.setItem('first_name', response.data.identity.first_name)
            localStorage.setItem('user_id', response.data.identity.user_id)
            localStorage.setItem('roles', response.data.identity.roles)
            localStorage.setItem('expires_at', response.data.expiry)
            localStorage.setItem('org_id', response.data.identity.organisation)
            // console.log("Login succesfull so set interval")
            setInterval(this.refreshTokens, 300000)
            return response
        })
        .catch(error => {
            if (error.response) { 
                return error.response
            }
        })
    }

    refreshTokens () {
        // console.log("Token refresh at", new Date())
        return axios.post(((store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/refresh', {} ,{ headers: getHeadersWithRefreshToken() })
        .then(response => {
            localStorage.setItem('access_token', response.data.access_token)
            localStorage.setItem('expires_at', response.data.expiry)
            return response
        })
        .catch(error => {
            return error.response
        })

    }

    logout () {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('first_name')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('user_id')
        localStorage.removeItem('roles')
        localStorage.removeItem('org_id')
    }

    getUsername () {
        if (this.isAccessTokenValid()) {
            return String(localStorage.getItem('first_name'))
        }
    }

    inviteUser (email) {
        return axios.post(((store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/invite', {'email': email} ,{ headers: getHeadersWithAccessToken() })
        .then(response => {
            return response
        })
        .catch(error => {
            if (error.response) { 
                return error.response
            }
        })

    }

    resetPassword (email, token, password) {
        return axios.put(((store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/change', {'email': email, 'token': token, 'password': password} ,{ headers: headers })
        .then(response => {
            return response
        })
        .catch(error => {
            if (error.response) { 
                return error.response
            }
        })

    }

    forgotPassword (email) {
        return axios.post(((store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/forgot', {'email': email} ,{ headers: headers })
        .then(response => {
            return response
        })
        .catch(error => {
            if (error.response) { 
                return error.response
            }
        })

    }
}

const authService = new Auth();
export default authService;
